export enum CoverType {
    GALLERY     = 'gallery',
    LINK        = 'link',
    ATTACHMENT  = 'attachment',
}